import React from "react";
import { useProductCardContext } from "web/react/components/product-card/react";
import SaveForLaterButton from "web/react/components/save-for-later-button/save-for-later-button";
import { ProductStatus } from "web/redux/ducks/customer-capture-overlay";
import userProfiler from "web/script/modules/userprofiler";
import * as styles from "./product-card-wishlist.css";

interface ProductCardWishlistProps {
    isAffiliate?: boolean;
    isSavedForLater: boolean;
    beforeOnClick?: (any?) => void;
    productPosition?: number;
}

export function ProductCardWishlist({
    isAffiliate,
    isSavedForLater,
    beforeOnClick,
    productPosition,
}: ProductCardWishlistProps): React.ReactElement | null {
    const {
        id,
        image_url: imageURL,
        app_deeplink_path: appDeepLinkPath,
        in_stock: inStock,
        sale_discount: saleDiscount,
        link_id: linkId,
        designer_name: designerName,
        short_description: shortDescription,
    } = useProductCardContext();

    const productStatus: ProductStatus = !inStock
        ? "out_of_stock"
        : saleDiscount
        ? "on_sale"
        : "in_stock";

    const productName = [designerName, shortDescription].filter(Boolean).join(" ");

    return (
        <span className={styles.wishlist}>
            <SaveForLaterButton
                type="icon"
                isLoggedIn={userProfiler.isLoggedIn()}
                pageSource="feed"
                productId={id.toString()}
                productName={productName}
                productImageURL={imageURL?.toString()}
                productStatus={productStatus}
                isAffiliate={isAffiliate}
                appDeeplinkPath={appDeepLinkPath}
                variant={"emotional"}
                initialIsSaved={isSavedForLater}
                beforeOnClick={beforeOnClick}
                productPosition={productPosition}
                linkId={linkId}
            />
        </span>
    );
}
